import { render, staticRenderFns } from "./RestrictionDialog.vue?vue&type=template&id=85594a50&"
import script from "./RestrictionDialog.vue?vue&type=script&lang=ts&"
export * from "./RestrictionDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports